import { render, staticRenderFns } from "./LinesWave.vue?vue&type=template&id=20038755&scoped=true&"
import script from "./LinesWave.vue?vue&type=script&lang=js&"
export * from "./LinesWave.vue?vue&type=script&lang=js&"
import style0 from "./LinesWave.vue?vue&type=style&index=0&id=20038755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20038755",
  null
  
)

export default component.exports